import React, { useEffect, useState } from "react";
import Image from "next/image";
import clsx from "clsx";
import {
  Box,
  Typography,
  Container,
  Grid,
  Button,
  Tab,
  Tabs,
} from "@mui/material";

import HomeLayout from "layouts/HomeLayout";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import i18n from "i18next";

// actions
import { getNewsList, getSpecialNews } from "context/actions/news";
import { getRegionList } from "context/actions/region";
import { getLinkList } from "context/actions/link";
import { getPartnerList } from "context/actions/partner";
import { getCoverList } from "context/actions/cover";
import { getYoutubeList } from "context/actions/youtube";
import { getSpecialAlert } from "context/actions/alert";
import { getView, insertView } from "context/actions/view";

// components
import TabPanel from "components/TabPanel";
import TabPanelRegion from "components/TabPanelRegion";
import Slider from "components/Slider";
import Organization from "components/Organization";
import Introduction from "components/Introduction";
import Video from "components/Video";
import BestList from "components/BestList";
import NewsTabButton from "components/NewsTabButton";
import RegionTabButton from "components/RegionTabButton";
import NewsItem from "components/NewsItem";
import RegionItem from "components/RegionItem";
import AlertPopUp from "components/AlertPopUp";
import Views from "components/Views";
import VideoPlayer from "components/VideoPlayer";

const HomePage = ({}) => {
  const { t } = useTranslation();

  const [specialNews, setSpecialNews] = useState([]);
  const [allNews, setAllNews] = useState([]);
  const [timeNews, setTimeNews] = useState([]);
  const [videoNews, setVideoNews] = useState([]);
  const [photoNews, setPhotoNews] = useState([]);
  const [warningNews, setWarningNews] = useState([]);
  const [link, setLink] = useState([]);
  const [partner, setPartner] = useState([]);
  const [cover, setCover] = useState([]);
  const [youtube, setYoutube] = useState([]);
  const [alert, setAlert] = useState(null);
  const [viewData, setView] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  //region
  const [western, setWestern] = useState([]);
  const [central, setCentral] = useState([]);
  const [gobi, setGobi] = useState([]);
  const [eastern, setEastern] = useState([]);
  const [northern, setNorthern] = useState([]);
  const [khangai, setKhangai] = useState([]);

  const [tabRegionValue, setTabRegionValue] = useState(0);

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    const resANews = await getNewsList("", 1, 3, "", 1);
    if (resANews.status === "success") setAllNews(resANews.data.list);

    const resSNews = await getSpecialNews();
    if (resSNews.status === "success") setSpecialNews(resSNews.data.list);

    const resLink = await getLinkList();
    if (resLink.status === "success") setLink(resLink.data);
    const resPartner = await getPartnerList();
    if (resPartner.status === "success") setPartner(resPartner.data);
    const resCover = await getCoverList();
    if (resCover.status === "success") setCover(resCover.data);
    const resYoutube = await getYoutubeList();
    if (resYoutube.status === "success") setYoutube(resYoutube.data);
    const resAlert = await getSpecialAlert();
    if (resAlert.status === "success") setAlert(resAlert.data);
    const resViewInsert = await insertView();
    const resView = await getView();
    if (resView.status === "success");
    setView(resView.data);

    const resW = await getRegionList("", 1, 3, "western");
    if (resW.status === "success") setWestern(resW.data.list);

    const resC = await getRegionList("", 1, 3, "central");
    if (resC.status === "success") setCentral(resC.data.list);

    const resG = await getRegionList("", 1, 3, "gobi");
    if (resG.status === "success") setGobi(resG.data.list);

    const resE = await getRegionList("", 1, 3, "eastern");
    if (resE.status === "success") setEastern(resE.data.list);

    const resN = await getRegionList("", 1, 3, "northern");
    if (resN.status === "success") setNorthern(resN.data.list);

    const resK = await getRegionList("", 1, 3, "khangai");
    if (resK.status === "success") setKhangai(resK.data.list);
  };

  const handleChangeTab = (newValue) => {
    setTabValue(newValue);
  };

  const handleChangeRegionTab = (newValue) => {
    setTabRegionValue(newValue);
  };

  const closeAlert = () => {
    setAlert(null);
  };

  return (
    <Container maxWidth={false} disableGutters={true}>
      <Container
        maxWidth={"lg"}
        style={{
          // display: 'flex',
          // flexDirection: 'column',
          // background: '#f5f6fa',
          marginTop: 160,
          marginBottom: 22,
          // padding: '80px 0 0px 0',
        }}
        id={"advantage"}
      >
        <Slider linkData={specialNews} />
      </Container>
      <div
        style={{
          backgroundColor: "#f8f8f8",
          paddingTop: 50,
          paddingBottom: 50,
        }}
      >
        <Container
          maxWidth={"lg"}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
          id={"advantage"}
        >
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 600,
              marginBottom: 10,
            }}
            className="text-primary-900"
          >
            {t("news")}
          </Typography>
          <Grid
            container
            spacing={4}
            direction={"row"}
            // className={`cursor-pointer ${last ? '' : 'border-b'} py-4 `}
          >
            {allNews.map((item, ind) => {
              return (
                <Grid key={ind} item lg={4} md={4} sm={6} xs={12}>
                  <NewsItem
                    key={ind}
                    newsId={item.id}
                    imageUrl={item.imageUrl}
                    date={item.createdAtDay}
                    name={i18n.language === "en" ? item.nameEng : item.name}
                    description={
                      i18n.language === "en"
                        ? item.descriptionEng
                        : item.description
                    }
                    last={allNews.length === ind + 1 ? true : false}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </div>

      <Container
        maxWidth={"lg"}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
        id={"advwantage"}
      >
        <Image
          width={1}
          height={1}
          src="/bannerMain.jpg"
          unoptimized
          layout="responsive"
          alt=""
          objectFit={"cover"}
          className="rounded-lg mt-16"
        />
      </Container>

      <Container
        maxWidth={"lg"}
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 20,
          marginBottom: 20,
        }}
        id={"advantage"}
      >
        <Video linkData={youtube} />
        {/* <BestList linkData={link} /> */}
      </Container>

      <Container
        maxWidth={"xxl"}
        style={{
          display: "flex",
          flexDirection: "column",
          background: "#f5f6fa",
        }}
        id={"advantage"}
      >
        <Organization linkData={partner} />
      </Container>
      <Container
        maxWidth={"lg"}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
        id={"advantage"}
      >
        <Views viewValue={viewData} />
      </Container>

      {alert && alert.imageUrl && (
        <AlertPopUp open={true} handleClose={closeAlert} alert={alert} />
      )}
    </Container>
  );
};

HomePage.Layout = HomeLayout;

export default HomePage;
